import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  applyDiscountBtn: {
    width: 200
  },
  removeDiscountBtn: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center'
  },
  removeIcon: {
    width: 24,
    height: 24,
    marginRight: 8
  },
  buttonContainer: {
    marginTop: theme.spacing(8)
  }
}));

export default useStyles;
